<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3q5ZYM/tc-custom/9781788633482.jpg?1701060645929" alt="This image is the cover for the book Sleeping Sword, The Barforth Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sleeping Sword, The Barforth Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Victorian woman defies convention and follows her heart to freedom in this conclusion to the Barforth Trilogy from the author of <i>Flint and Roses</i>. </b><br/>  <br/> Grace Agbrigg has ambitions beyond merely ornamenting the home of a rich husband. But Victorian England is still almost wholly a man’s world in which women—rich or poor—must do the bidding of the father, husband or employer.<br/>  <br/> Attracted against her will to the ambitious and ruthless Gideon Chard, Grace instead makes the marriage that is expected of her. But eventually she breaks free of a relationship that is a sham to become the only divorcee in Cullingford. Cast out by society, Grace is faced with a future she never expected—one in which she holds the keys to her own happiness.<br/>  <br/> Set against a background of change and unrest, of dazzling wealth cheek by jowl with bitter poverty, this conclusion to the Barforth Trilogy is perfect for fans of Sandy Taylor, Katie Flynn and Josephine Cox. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brenda Jagger
      </h2>
      
      <p class="authorDescription body article"><P>Brenda Jagger was born in Yorkshire like so many of the characters in the Barforth Trilogy. Married with three daughters, she worked in Paris, Dundee and then in the north of England as a probation officer. Her work with 'wayward girls' and her own family increased her interest in women's experiences, both within her own lifetime and historically. In 1986, her last novel A Song Twice Over won the Romantic Novel of the Year Award by the Romantic Novelists' Association.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?89dd7690